(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header--shop-subnav"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
		const navItems = document.querySelectorAll(".shop-subnav__list .nav__item");
		const [previewImage1, previewImage2] = document.querySelectorAll(".shop-subnav__preview .subnav-preview__image");

		navItems.forEach(link => {
			link.addEventListener("mouseenter", () => {
				const img1 = link.dataset["image-1"];
				const img2 = link.dataset["image-2"];

				if (img1) {
					previewImage1.src = img1;
					previewImage1.style.display = "block";

				} else {
					previewImage1.style.display = "none";
				}

				if (img2) {
					previewImage2.src = img2;
					previewImage2.style.display = "block";

				} else {
					previewImage2.style.display = "none";
				}
						
			});

			link.addEventListener("mouseleave", () => {
				previewImage1.style.display = "none";
				previewImage2.style.display = "none";
			});
		});
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header"] && !Shopify.designMode) return;
  try {
    const mobileMenu = document.querySelector("#nav__mobile-menu");
    const menuButton = document.querySelector("#nav__menu-button");

    function setMenuState(active) {
        mobileMenu.classList.toggle("active", active);
        menuButton.setAttribute("aria-expanded", active);
        menuButton.textContent = active ? "Close" : "Menu";
        document.body.style.overflow = active ? "hidden" : "";
    }

    menuButton.addEventListener("click", () => {
        const active = !mobileMenu.classList.contains("active");
        setMenuState(active);
    });

    const mediaQuery = window.matchMedia("(min-width: 900px)");
    mediaQuery.addEventListener("change", (e) => {
        if (e.matches) setMenuState(false);
    });

    const shopAllButton = document.querySelector(".nav__item--shop-all");
    
    if (shopAllButton) {
        const shopSubNav = document.querySelector(".nav__shop-subnav");
        const shopAllHeader = document.querySelector("header");

        shopAllButton.addEventListener("mouseenter", (event) => {
            shopSubNav.classList.add("nav__shop-subnav--open");
        });

        shopAllHeader.addEventListener("mouseleave", (event) => {
            shopSubNav.classList.remove("nav__shop-subnav--open");
        });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-embed"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll("[data-dismiss-id]").forEach(embed => {
            const id = embed.dataset.dismissId
            const storageKey = `newsletter-dismissed-${id}`

            if (localStorage.getItem(storageKey)) {
                embed.style.display = "none"
            }

            const btn = embed.querySelector(".newsletter-dismiss");
            if (btn) {
                btn.addEventListener("click", () => {
                    localStorage.setItem(storageKey, "true")
                    embed.style.display = "none"
                })
            }
        })
    })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product--description"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll(".product__details-wrapper").forEach((wrapper) => {
        const toggles = wrapper.querySelectorAll(".product__details-toggle");

        toggles.forEach((toggle) => {
            toggle.addEventListener("click", () => {
                const open = toggle.getAttribute("aria-expanded") !== "true";

                toggles.forEach((other) => {
                    const isTarget = other === toggle && open;
                    other.setAttribute("aria-expanded", isTarget);
                    document.getElementById(other.getAttribute("aria-controls")).hidden = !isTarget;
                });
            });
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product--images"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
        /* DESKTOP STUFF */

        const mediaWrappers = document.querySelectorAll(".product__media-wrapper");
        const counterCurrent = document.querySelector(".product__counter--desktop .product__counter-current--desktop");

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                const index = [...mediaWrappers].indexOf(entry.target);
                counterCurrent.textContent = index + 1;
                }
            });
        }, {
            threshold: 0,
            rootMargin: "0px 0px -90% 0px"
        });

        mediaWrappers.forEach(wrapper => observer.observe(wrapper));

        /* MOBILE STUFF */

        let swiper

        const initCarousel = () => {
            const list = document.querySelector(".product__media-list")
            const inner = document.querySelector(".product__media-list-inner")
            const slides = document.querySelectorAll(".product__media-wrapper")

            list.classList.add("swiper")
            inner.classList.add("swiper-wrapper")
            slides.forEach(slide => slide.classList.add("swiper-slide"))

            swiper = new Swiper(".product__media-list", {
                slidesPerView: 1,
                on: {
                    progress: function(swiper, progress) {
                        const bar = document.querySelector(".product__progress-bar")
                        const totalSlides = swiper.slides.length
                        const barWidth = 100 / totalSlides
                        const barPosition = progress * (100 - barWidth)
                        bar.style.width = `${barWidth}%`
                        bar.style.transform = `translateX(${barPosition * totalSlides}%)`
                    },
                    slideChange: function() {
                        const current = document.querySelector(".product__counter-current")
                        current.textContent = swiper.activeIndex + 1
                    },
                    afterInit: function(swiper) {
                        const total = document.querySelector(".product__counter-total")
                        const bar = document.querySelector(".product__progress-bar")
                        total.textContent = swiper.slides.length
                        bar.style.width = `${100 / swiper.slides.length}%`
                    }
                }
            })
        }

        const initSwiper = () => {
            loadSwiper(initCarousel)
        }

        const mediaQuery = window.matchMedia("(max-width: 900px)")

        mediaQuery.addEventListener("change", (e) => {
            if (e.matches) {
                initSwiper()
            } else {
                if (swiper) {
                    const list = document.querySelector(".product__media-list")
                    const inner = document.querySelector(".product__media-list-inner")
                    const slides = document.querySelectorAll(".product__media-wrapper")

                    swiper.destroy(true, true)
                    list.classList.remove("swiper")
                    inner.classList.remove("swiper-wrapper")
                    slides.forEach(slide => slide.classList.remove("swiper-slide"))
                    swiper = null
                }
            }
        })

        if (mediaQuery.matches) {
            initSwiper()
        }
    })
  } catch(e) { console.error(e); }
})();

})();
